// Moving between rows of one column in the batch table, as in a spreadsheet:
// Enter or ArrowDown goes to the same column in the next shown row, Shift+Enter or
// ArrowUp to the previous one. Cells carry data-col and data-row; the table root
// carries data-sample-table.

export const TABLE_ATTR = 'data-sample-table'

/** 1 (next row), -1 (previous row) or 0 (not a row move) for a keydown event. */
export const rowStepOf = (e) => {
  if (!e || e.altKey || e.ctrlKey || e.metaKey) return 0
  if (e.nativeEvent?.isComposing || e.isComposing) return 0
  if (e.key === 'Enter') return e.shiftKey ? -1 : 1
  if (e.shiftKey) return 0
  if (e.key === 'ArrowDown') return 1
  if (e.key === 'ArrowUp') return -1
  return 0
}

/** Keydown handler for a cell input: focuses the same column in the next or previous row. */
export const moveInColumn = (e) => {
  const step = rowStepOf(e)
  const input = e.target
  if (!step || !input?.dataset?.col || typeof input.closest !== 'function') return
  const table = input.closest(`[${TABLE_ATTR}]`)
  if (!table) return
  const current = Number(input.dataset.row)
  const cells = Array.from(table.querySelectorAll(`[data-col="${input.dataset.col}"]`))
    .filter((el) => !el.disabled && el.dataset.row !== undefined)
    .sort((a, b) => Number(a.dataset.row) - Number(b.dataset.row))
  const next =
    step > 0
      ? cells.find((el) => Number(el.dataset.row) > current)
      : [...cells].reverse().find((el) => Number(el.dataset.row) < current)
  if (!next) return
  e.preventDefault()
  next.focus()
  if (typeof next.select === 'function') next.select()
}
